<template>
  <div>
    <div class="tabBox">
      <div class="yearClose"></div>
      <p class="title1">请选择感兴趣的课程</p>
      <p class="text1">为您推荐更多课程（可随时更改，请放心选择）</p>
      <ul class="yearList">
        <li
          v-for="(item, index) in newData"
          :key="index"
          :class="{ active: item.code == selectedCode }"
          @click="change(item.code)"
        >
          <img :src="item.imgUrl" alt="" />
          <div :class="{ box: findRes(item) }">
            <p>{{ item.value }}</p>
            <span class="mark">{{ findRes(item) }}</span>
          </div>
        </li>
      </ul>
      <div class="confirmBtn" @click="confirmBtn">选好了</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { reqChoseRecords, reqTypeList } from '@/api/home';

export default {
  props: {
    newData: {
      type: Array,
      default: () => [],
    },
    currentExamYearInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showTop: false,
      markList: [
        {
          code: 8,
          name: '2023年12月考试',
        },
        {
          code: 10,
          name: '2024年12月考试',
        },
        {
          code: 12,
          name: '2025年12月考试',
        },
      ],
      selectedCode: '',
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 关闭年份选择
    closeYearBox() {
      this.$emit('closeYearBox', this.selectedCode);
    },
    // 选择tab
    change(code) {
      if (code == this.selectedCode) {
        this.selectedCode = '';
        return;
      }
      this.selectedCode = code;
    },
    // 选好了
    async confirmBtn() {
      const { selectedCode } = this;
      if (selectedCode) {
        reqChoseRecords({
          examTypeId: selectedCode,
        });
        // 25 26 下架后，该方法就不需要再掉用了
        this.$store.dispatch(
          'setcurrentyear',
          this.newData.find((ele) => ele.code == this.selectedCode),
        );

        // 修改考季
        setTimeout(() => {
          // 25 26 下架后，该方法就不需要再掉用了
          this.jumpNewExamYear(this.selectedCode);
          this.$emit('closeYearBox', this.selectedCode);
        }, 200);
      } else {
        this.$toast({
          message: '请选择注册类型',
          position: 'middle',
          duration: 2000,
        });
      }
    },
    jumpNewExamYear(code) {
      const arr = [3, 4, 5, 9, 10, 12];
      if (arr.find((item) => item == code)) {
        switch (Number(code)) {
          case 3:
            // 4会计 6计算机 3四六级 5大学生考试
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/cetIndex',
              query: {
                code,
              },
            });
            break;
          case 4:
            // 4会计 6计算机 3四六级 5大学生考试
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/accounting',
              query: {
                code,
              },
            });
            break;
          case 5:
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/collegeExam',
              query: {
                code,
              },
            });
            break;

          case 9:
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/japanIndex',
              query: {
                code,
              },
            });
            break;
          case 10:
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/exam25',
              query: {
                code,
              },
            });
            break;
          case 12:
            if (this.$root.$data.isApp) {
              this.appOpenPage(code);
            }
            this.$router.push({
              path: '/exam26',
              query: {
                code,
              },
            });
            break;
          default:
        }
      }
    },
    findRes(data) {
      const res = this.markList.find((item) => item.code === Number(data.code));
      return res?.name;
    },
  },
  created() {
    this.selectedCode = this.currentExamYearInfo.code;
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.cover {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2020;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.5);
  .tip1 {
    display: block;
    width: 90%;
    margin: 250px auto 100px;
  }
  .tip2 {
    display: block;
    width: 294px;
    height: 118px;
    margin: 0 auto;
  }
}
.tabBox {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  // display: none;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #fff;
}

.yearClose {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 36px 36px 42px 0;

  p {
    // width: 64px;
    height: 44px;
    margin-left: 9px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 32px;
    line-height: 44px;
  }

  img {
    width: 28px;
    height: 28px;
  }
}

.title1 {
  // margin-left: 53px;
  color: $fontColor;
  font-size: 48px;
  line-height: 66px;
  text-align: center;
}

.text1 {
  margin-top: 10px;
  // margin-left: 53px;
  color: $fontColor;
  font-size: 28px;
  line-height: 40px;
  text-align: center;
}

.yearList {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  // overflow-x: hidden;
  // height: calc(100% - 350px);
  padding: 100px 40px 6px;
  overflow-y: scroll;
  li {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 322px;
    height: 140px;
    margin: 0 20px 32px 0;
    background: #f5f7fb;
    border: 2px solid #f5f7fb;
    border-radius: 16px;

    img {
      width: 140px;
      height: 140px;
    }
    > div.box {
      p {
        padding-bottom: 20px;
      }
    }
    > div {
      position: relative;
      width: 182px;
      // height: 140px;
      // display: flex;
      // align-content: center;
      // align-items: center;
      // flex-wrap: wrap;
      p {
        width: 100%;
        padding: 0 10px 0 0;
        color: $fontColor;
        font-size: 32px;
        line-height: 44px;
        text-align: center;
      }
      .mark {
        position: absolute;
        right: 0;
        bottom: -2px;
        display: inline-block;
        width: 105%;
        color: #666;
        font-weight: 400;
        font-size: 20px;
        text-align: center;
        transform: scale(0.85);
      }
    }
  }
  li:nth-child(2n) {
    margin-right: 0;
  }
  .active {
    border: 2px solid #ff6c02;
  }
  .active::after {
    position: absolute;
    right: -2px;
    bottom: 0;
    display: block;
    width: 44px;
    height: 44px;
    background: url(../../../assets/img/loginImg/tabActive.png) no-repeat;
    background-size: 100% 100%;
    content: '';
  }
}

.confirmBtn {
  position: absolute;
  right: 0;
  bottom: 30px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 702px;
  height: 100px;
  margin: 0 auto;
  color: $bgWhite;
  font-weight: 500;
  font-size: 42px;
  background: #ff6c02;
  border-radius: 16px;
}
</style>
